module.exports = __webpack_public_path__ + "static/media/badgeIcon.d232dcb0.svg";